<div class="outer-content">
  <form [formGroup]="dependantDetailForm" autocomplete="off" role="form" class="fieldHeight">
    <div *ngIf="contentData" class="float-left bg-white card-background wh-auto">
      <app-content-top-nav [parentElement]="el" [parentFormToValidate]="dependantDetailForm" [visibleBackNav]='true' [enableBackNav]='!editMode' (onBackClickHandler)="OnBackClick()"></app-content-top-nav>
      <div class="col-md-12 clear-all title-wrapper">
        <h1 class="title-text custom-header-h2 responsive-text-8" id="dependantDetails-header">{{contentData.dependantDetail.header}}</h1>
      </div>
      <div class="col-md-12 clear-all content-wrapper">
        <p class="content-top dependantDetails" id="dependantDetails-introduction">
          {{contentData.dependantDetail.introduction}}
        </p>
        <!-- <div class="col-md-2 clear-all info-icon">
          <app-tool-tip-notification [childId]="'dependent'" [tooltipData]="userInputDetail.dependantDetailTitleInformation"></app-tool-tip-notification>
        </div> -->
      </div>
      <div class="col-md-12 content-sub-wrapper mb-mrg-top">
        <div class="col-md-12 clear-all pr-15">
          <app-question [childId]="'dependantQuestion'" [questionConfig]="userInputDetail.radioButtonDependantConfig" [parent]="dependantDetailForm"
            [controlName]="'dependantQuestion'" (toggleChange)="getToggleValue($event)" (onDisplayMobileTooltipEmitter)="displayTooltipMessage(userInputDetail.radioButtonDependantConfig)">
          </app-question>
        </div>
      </div>
      <div class="float-left inner-content-wrapper" *ngIf="displayContent">
        <div class="col-md-12 clear-all content-wrapper margin-0 content-padding sub-header">
          <p class="content-top" id="dependantDetails-introduction-sub">
            {{contentData.dependantDetail.introduction_sub}}
          </p>
          <div class="clear-all tool-tip-wrapper">
            <app-tool-tip-notification (qualifyingDependentInfoEmitter)="qualifyingDependentInfoReceiver($event)" 
            [childId]="'dependent'" [tooltipData]="userInputDetail.dependantDetailTitleInformation" 
            (closeModal)="closeModal()"
            (onDisplayMobileTooltipEmitter)="displayTooltipMessageForDependentAnnuity(userInputDetail.dependantDetailTitleInformation)"></app-tool-tip-notification>
          </div>
        </div>
        <div class="col-md-12 clear-all content-sub-wrapper margin-top-30 content-padding margin-top-8">
          <div class="col-md-7 clear-all">
            <app-date-input [minAge]="dependentMinAge" (onBlurHandler)="checkDataChange($event)" [pageName]="'dependant'" [parent]="dependantDetailForm"
              [controllerData]="userInputDetail.dependantDetailDob" formControlName="dateOfBirth" [tooltipData]="userInputDetail.dependantDetailTitleInformation"></app-date-input>
          </div>
        </div>
        <div class="col-md-12 clear-all content-sub-wrapper margin-top-30 content-padding">
          <div class="col-md-6 clear-all">
            <app-dropdown (onChangeHandler)="ddlChange($event)" [pageName]="'dependant'" [dropdownConfig]="userInputDetail.depandantDetailGenderConfig"
              [controlName]="'gender'" [parent]="dependantDetailForm">
            </app-dropdown>
          </div>
        </div>
        <div class="col-md-12 clear-all content-sub-wrapper margin-top-30 content-padding">
          <div class="col-md-6 clear-all">
            <app-dropdown (onChangeHandler)="ddlChange($event)" [dropdownConfig]="relationshipOptions" [pageName]="'dependant'" [controlName]="'relationship'"
              [parent]="dependantDetailForm">
            </app-dropdown>
          </div>
        </div>
      </div>
      <div class="col-md-12 underline margin-top">
      </div>

      <app-modal *ngIf="displayAlert" [modalConfig]="alertModalConfig" (closeModal)="closeModal()" (primaryBtnClick)="alertPrimaryBtnClick()"
        (secondaryBtnClick)="alertSecondaryBtnClick()" [saveDataFlag]="false"></app-modal>

      <app-modal *ngIf="ageValidatorFlag" [modalConfig]="ageAlertModalConfig" (closeModal)="closeAgeModal()" (primaryBtnClick)="alertAgePrimaryBtnClick()"
        (secondaryBtnClick)="alertAgeSecondaryBtnClick()" [saveDataFlag]="false"></app-modal>

      <app-modal *ngIf="depChangeValidatorFlag" [modalConfig]="depChangeAlertModalConfig" (closeModal)="closeDepChangeModal()" (primaryBtnClick)="depChangePrimaryBtnClick()"
        (secondaryBtnClick)="alertAgeSecondaryBtnClick()" [saveDataFlag]="false"></app-modal>

        <ng-container *ngIf="showModalForCardRefresh">

        <app-modal [modalConfig]="alertCardRefreshModalConfig" (closeModal)="closeCardRefreshModal()" (primaryBtnClick)="alertPrimaryBtnClickinModal()"
          (secondaryBtnClick)="alertSecondaryCardRefreshBtnClick()" [saveDataFlag]="false"></app-modal>
        </ng-container>

        <app-modal *ngIf="displayTooltipAlert" [modalConfig]="tooltipModalConfig" (closeModal)="closeModal()"
            (primaryBtnClick)="alertTooltipPrimaryBtnClick($event)" (secondaryBtnClick)="alertSecondaryBtnClick()"
            [tooltipFlag]="true"></app-modal>

      <div class="col-md-12 clear-all bottom-container">
        <div class="float-left">
          <app-save [parentElement]="el" [parentFormToValidate]="dependantDetailForm" [location]="'contentBottom'"></app-save>
        </div>
        <div class="float-right">
          <app-content-bottom-nav (onNextHandler)="gotoNext()" [userInputDetail]="userInputDetail['buttonConfig']" [buttonType]="'normalCTA'"></app-content-bottom-nav>
        </div>
      </div>
    </div>
  </form>
</div>